export default __webpack_public_path__ + "static/media/V230_CoC.9241a514.pdf";